import { useEffect, useRef, useState, useCallback } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../constant';

const initialState = {
    q: '',
    page: 1,
    per_page: 24,
    sort: 'relevance',
    filters: { stock_status: [], categories: [], brand: [], price: {} },
    facet_query: {},
};

export default function useNativeSearch() {
    const [state, setState] = useState(initialState);
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const reqId = useRef(0);

    useEffect(() => {
        const t = setTimeout(async () => {
            const me = ++reqId.current;
            setLoading(true);
            try {
                const res = await axios.post(`${API_BASE_URL}/search`, state);
                if (me === reqId.current) setData(res.data);
            } finally {
                if (me === reqId.current) setLoading(false);
            }
        }, 250);
        return () => clearTimeout(t);
    }, [state]);

    const setQuery = useCallback((q) =>
        setState((s) => ({ ...s, q, page: 1 })), []);

    const toggleFilter = useCallback((facet, value) => {
        setState((s) => {
            const cur = s.filters[facet] || [];
            const next = cur.includes(value)
                ? cur.filter((v) => v !== value)
                : [...cur, value];
            return { ...s, page: 1, filters: { ...s.filters, [facet]: next } };
        });
    }, []);

    const setPrice = useCallback((min, max) =>
        setState((s) => ({
            ...s,
            page: 1,
            filters: {
                ...s.filters,
                price: { min: min ?? undefined, max: max ?? undefined },
            },
        })), []);

    const setSort = useCallback((sort) =>
        setState((s) => ({ ...s, sort, page: 1 })), []);

    const setPage = useCallback((page) =>
        setState((s) => ({ ...s, page })), []);

    const setFacetQuery = useCallback((facet, text) =>
        setState((s) => ({
            ...s,
            facet_query: { ...s.facet_query, [facet]: text || undefined },
        })), []);

    const clearAll = useCallback(() => setState(initialState), []);

    return {
        state, data, loading,
        setQuery, toggleFilter, setPrice, setSort, setPage, setFacetQuery, clearAll,
    };
}
